export const kWeekInMilliseconds = 1000 * 60 * 60 * 24 * 7;

// -----------------------------------------------------------------------------
export class Utils {
  private static _persistentPhase: number;
  // ---------------------------------------------------------------------------
  public static deepClone<T>(obj: T): T {
    return JSON.parse(JSON.stringify(obj)) as T;
  }

  // ---------------------------------------------------------------------------
  public static randomWholeNumber(min: number, max: number): number {
    return Math.floor(Math.random() * (max - min + 1) + min);
  }

  // ---------------------------------------------------------------------------
  // TODO(twolf): Consider a TimeCalcService
  public static calcTimePassedInWeeks(timestamp: number) {
    if (timestamp === 0) {
      return 0;
    }

    return (Date.now() - timestamp) / kWeekInMilliseconds;
  }

  // ---------------------------------------------------------------------------
  public static getPersistentPhasedPercent(version: string) {
    if (this._persistentPhase) {
      return this._persistentPhase;
    }

    const hash = this.stringToHash(version);
    this._persistentPhase = hash % 100;
    return this._persistentPhase;
  }

  // ---------------------------------------------------------------------------
  private static stringToHash(str: string): number {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = (hash * 31 + str.charCodeAt(i)) % 10000;
    }

    const randomComponent = Math.floor(Math.random() * 100);
    return hash + randomComponent;
  }
}
